import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './estilos/global.css';
import { App } from './App.js';
import { ProveedorApp } from './estado/app.js';

/**
 * Arranque.
 *
 * El service worker se registra con `registerType: 'prompt'` (ver
 * vite.config.ts): una actualización NO se aplica sola a mitad de una
 * limpieza. Recargar la pestaña mientras se graba sería perder el clip en
 * curso, así que la versión nueva espera a que la cola esté vacía y la app en
 * la pantalla del día.
 */
const raiz = document.getElementById('raiz');
if (raiz === null) {
    throw new Error('falta #raiz en index.html');
}

createRoot(raiz).render(
    <StrictMode>
        <ProveedorApp>
            <App />
        </ProveedorApp>
    </StrictMode>
);

// Registro del service worker. Se hace aquí y no en un módulo aparte para que
// se vea que la app funciona igual sin él: el service worker sirve para
// arrancar sin red, no para subir. La cola vive en la pestaña.
void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({
        immediate: false,
        onRegisteredSW(_url, registro) {
            // Una comprobación al día basta: la app la abre la misma persona
            // cada mañana y no queremos gastar datos comprobando cada hora.
            setInterval(
                () => {
                    void registro?.update();
                },
                24 * 60 * 60 * 1000
            );
        },
    });
});
